import { ref } from 'vue'
import { publicService } from '../services/public'

const emptyMessages = ref({})
let loadingPromise = null
let loaded = false

const loadEmptyMessages = async () => {
  if (loaded) return
  if (loadingPromise) return loadingPromise

  loadingPromise = (async () => {
    try {
      const response = await publicService.getBookEmptyMessages()
      if (response && response.messages) {
        emptyMessages.value = response.messages
        loaded = true
      } else {
        console.warn('Empty messages response missing messages from database')
      }
    } catch (error) {
      console.error('Failed to load empty messages from database:', error)
    } finally {
      loadingPromise = null
    }
  })()

  return loadingPromise
}

loadEmptyMessages()

export function useEmptyMessages () {
  const getEmptyMessage = (key, query = null) => {
    const message = emptyMessages.value[key]
    if (!message) {
      console.warn(`Empty message not found for key: ${key}`)
      return ''
    }
    if (key === 'search' && query) {
      return message.replace('{{query}}', query)
    }
    return message
  }

  return {
    emptyMessages,
    getEmptyMessage,
    loadEmptyMessages
  }
}
